export default "__VITE_ASSET__Bugod9EB__"